import * as TYPES from './types';
import util from "@/common/util";
import { sortAgentSocialNetworks } from '@/common/agents';

const getAgentRequest = async function(ids, agentShape) {
    const res = await this.axiosIns.post('/api-graphql', {
        query: `{agents(ids: "${ids}"){firstName,lastName,image,phone,email,position,license,headShots{photoFiveByThree,photoOneByOne,photoThreeByFour}}}`
    });

    const agents = (res.data && res.data.agents) || [];
    return agents
        .filter(agent => {
            return agent && (agent.firstName || agent.lastName);
        })
        .map(agent => {
            if (!agent.image) {
                if (agentShape === 'circle') {
                    agent.image =
                        'https://cdn.chime.me/image/fs/sitebuild/2019916/23/original_96b7f1a8-9f97-424d-852a-ae5214ba95e9.png';
                } else {
                    agent.image = 'https://cdn.chime.me/image/fs/sitebuild/202457/7/original_fbb918b4-831d-43d3-8d96-68f8986a8e79.png';
                }
            }
            return agent;
        });
}

export default {
    [TYPES.SET_FORMLISTSTATE](payload = []) {
        this.formListState = payload;
    },
    [TYPES.SET_AGENTS](payload = []) {
        this.agents = payload
    },
    [TYPES.GET_FORMREQUIRED]() {
        return this.axiosIns.get('/api-site/place-data?fetcher=data&source=formRequired')
            .then(res => {
                let data = res.data || {};
                if (util.isString(data)) {
                    data = JSON.parse(data)
                }
                return data;
            })
    },
    async [TYPES.GET_AGENTS](payload = {}) {
        let { agentId, secondAgentId, agentShape } = payload;
        let ids = new Set();
        agentId = agentId === -1 ? 0 : agentId;
        ids.add(agentId);
        secondAgentId = secondAgentId === -1 ? 0 : secondAgentId;
        ids.add(secondAgentId);
        ids = Array.from(ids);
        if (!(ids.includes(0) || ids.includes('0'))) {
            ids = [ids.join(',')];
        }
        const ps = ids.map(id => getAgentRequest.call(this, id, agentShape));
        const list = await Promise.all(ps);
        this[TYPES.SET_AGENTS](list.flat(Infinity))
       
    },
    [TYPES.GET_TEAM_SLIDER_AGENTS](payload = "") {
        return this.axiosIns.post('/api-graphql', {
            query: `{agents(ids: "${payload}"){fullName,image,phone,email,headShots{photoFiveByThree,photoOneByOne,photoThreeByFour},agentSocialNetworks{url,socialNetwork},externalUrl,id}}`
        })
            .then(res => {
                let agents = res.data?.agents || [];
                agents = agents.map(agent => ({
                    ...agent,
                    agentSocialNetworks: sortAgentSocialNetworks(
                        agent.agentSocialNetworks
                    )
                }));
                this[TYPES.SET_AGENTS](agents)
            });
    }
}